import { Box, Heading, Stack, Text, VStack } from '@chakra-ui/react'
import React from 'react'

import { responsive } from '../../contexts/responsive'
import parseHtml from '../../helpers/parseHtml'
import HtmlWrapper from '../Blocks/Collection/HtmlWrapper'
import RatioImage from '../RatioImage'

const imageRatio = {
  image: 2,
  mobileBackground: 0.5,
}

const textAlign = {
  'flex-start': 'left',
  'flex-end': 'right',
  center: 'center'
}

const Thanks = ({
  thanksAlign = 'center',
  thanks,
  thanksImage,
  thanksImageType,
  supporter,
  profileName,
  isEditing,
  isPreview,
  count = '#',
}) => {
  // const [downloadUrl, setDownloadUrl] = useState(thanksImage)
  // useEffect(() => {
  //   if (downloadable) {
  //     try {
  //       var xhr = new XMLHttpRequest();
  //       xhr.open("GET", imageRef.current.src);
  //       xhr.responseType = "blob";
  //       xhr.onload = function () {
  //         if (xhr.status === 200) {
  //           setDownloadUrl(URL.createObjectURL(xhr.response))
  //         }
  //       };
  //       xhr.send();
  //     }
  //     catch (err) {
  //       console.error(err)
  //     }
  //   }
  // }, [downloadable])
  return (
    <VStack spacing={6} alignItems={thanksAlign} w="full">
      <Heading as="h2" fontSize={responsive('1.125em', '1.375em')} fontWeight="500" color="custom.primary" lineHeight="1.75" textAlign={textAlign[thanksAlign]}>
        你是 {profileName} 的<br />第 {count} 號{supporter || '支持者'}
      </Heading>
      <HtmlWrapper w="full" px="4">
        {thanks && thanks !== '<p></p>' ? parseHtml(thanks) : ((isEditing || isPreview) && '感謝文字預覽')}
      </HtmlWrapper>
      <Box rounded="md" overflow="hidden" boxShadow="md" width="100%">
        <RatioImage
          ratio={imageRatio[thanksImageType] || 2}
          isPreview
          isEditing
          src={thanksImage}
        />
      </Box>
      {/* {downloadable && <Button isDisabled={isEditing} as="a" href={downloadUrl} download leftIcon={<MdFileDownload />} colorScheme="primary">下載圖片</Button>} */}
    </VStack>
  )
}

export default Thanks
